import {
  LOGIN_REQUEST,
  VERIFY_DEVICE_OTP_REQUEST,
  RESEND_OTP_REQUEST,
  LOGOUT_REQUEST,
  REGISTER_REQUEST,
  FORGOT_PASSWORD_REQUEST,
  RESET_PASSWORD_REQUEST,
  REFRESH_TOKEN_REQUEST,
  ACTIVATE_REQUEST,
  REGISTER_SUCCESS,
  RESEND_ACTIVATION_EMAIL
} from './types';

/**
 * LOGIN
 */
export const loginRequest = (data, notifyForm, otpCallbacks) => ({
  type: LOGIN_REQUEST,
  payload: {
    data,
    notifyForm,
    otpCallbacks
  }
});

/**
 * VERIFY_DEVICE_OTP
 *
 * callbacks: { shouldApply, onSuccess, onError, onSettled } — shouldApply gates
 * late responses so a cancelled OTP flow never mutates auth state; onSettled
 * fires on every outcome (success, gated drop, error)
 */
export const verifyDeviceOtpRequest = (data, callbacks) => ({
  type: VERIFY_DEVICE_OTP_REQUEST,
  payload: {
    data,
    callbacks
  }
});

/**
 * RESEND_OTP
 *
 * callbacks: { shouldApply, onSuccess, onError, onSettled } — same gating
 * contract as VERIFY_DEVICE_OTP; onSuccess receives the raw response so the
 * caller can pick up a rotated verificationTokenHash
 */
export const resendOtpRequest = (verificationTokenHash, callbacks) => ({
  type: RESEND_OTP_REQUEST,
  payload: {
    verificationTokenHash,
    callbacks
  }
});

/**
 * LOGOUT
 */
export const logoutRequest = () => ({
  type: LOGOUT_REQUEST
});

/**
 * REGISTER
 */
export const registerRequest = (data, notifyForm) => ({
  type: REGISTER_REQUEST,
  payload: { data, notifyForm }
});
export const registerSuccess = request => ({
  type: REGISTER_SUCCESS,
  payload: {
    request
  }
});

/**
 * REFRESH_TOKEN
 */
export const refreshTokenRequest = (type, payload) => ({
  type: REFRESH_TOKEN_REQUEST,
  payload: {
    type,
    payload
  }
});

/**
 * ACTIVATE_REQUEST
 */
export const activateRequest = (token, memberId) => ({
  type: ACTIVATE_REQUEST,
  payload: {
    token,
    memberId
  }
});
/**
 * RESEND_ACTIVATION_EMAIL
 */
export const resendActivationEmailRequest = (email) => ({
  type: RESEND_ACTIVATION_EMAIL,
  payload: {
    email
  }
});

/**
 * FORGOT_PASSWORD
 */
export const forgotPasswordRequest = (data, notifyForm) => ({
  type: FORGOT_PASSWORD_REQUEST,
  payload: {
    data,
    notifyForm
  }
});

/**
 * RESET_PASSWORD
 */
export const resetPasswordRequest = (data, redirect, notifyForm) => ({
  type: RESET_PASSWORD_REQUEST,
  payload: {
    data,
    redirect,
    notifyForm
  }
});
